import { Icon, IconProps, Text, TextProps } from '@shopify/polaris';
import { InfoIcon } from '@shopify/polaris-icons';
import React from 'react';
import { InlineWarningStyled } from './styled';

interface IProps {
  message: React.ReactNode;
  iconTone?: IconProps['tone'];
  textTone?: TextProps['tone'];
}

const InlineWarning = (props: IProps) => {
  return (
    <InlineWarningStyled>
      <Icon source={InfoIcon} tone={props.iconTone ?? 'caution'} />
      <Text as="span" tone={props.textTone ?? 'caution'}>
        {props.message}
      </Text>
    </InlineWarningStyled>
  );
};

export default InlineWarning;
